import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { getLegalPages } from "./legalContent";
import { useLanguage } from "../shared/LanguageContext";
import { websiteCopy } from "../shared/websiteCopy";
import "./InfoPage.css";

function InfoPage() {
  const { language, t } = useLanguage();
  const copy = websiteCopy[language].info;
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const page = getLegalPages(language)[slug];

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/mirror-of-the-mind/book/product", { replace: true });
  };

  if (!page) {
    return (
      <main className="info-page" data-testid="info-page-not-found">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h1>{copy.unavailable}</h1>
        <p className="info-page__body">{copy.unavailableText}</p>
      </main>
    );
  }

  return (
    <main className="info-page" data-testid={`info-page-${page.slug}`}>
      <p className="eyebrow">{copy.eyebrow}</p>
      <h1 data-testid="info-page-title">{page.title}</h1>
      <div className="info-page__body">
        {page.effectiveDate && (
          <p><em>{copy.effective} {page.effectiveDate}</em></p>
        )}
        {page.content.map((item, i) => {
          if (item.type === "sectionHeading") {
            return <h3 key={i}>{item.text}</h3>;
          }
          return <p key={i}>{item.text}</p>;
        })}
      </div>
      <nav className="info-page__nav" data-testid="info-page-nav">
        <button
          type="button"
          onClick={handleBack}
          className="info-nav-link"
          data-testid="legal-back"
          aria-label={t("back")}
        >
          {t("back")}
        </button>
      </nav>
    </main>
  );
}

export default InfoPage;
